//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import ImageTextLeft from '~/components/section/image-text-left'
import SimpleImageTextRight from '~/components/section/simple-image-text-right'
import SimpleCoreValues from '~/components/section/simple-core-values'
import SectionText from '~/components/section/section-text'
import GallerySlider from '~/components/section/selection/gallery_slider'

export default {
  name: 'WorkWithTubber',
  components: {
    GallerySlider,
    SectionText,
    SimpleCoreValues,
    ImageTextLeft,
    SimpleImageTextRight
  },
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      let page = null
      const lang = ctx.store.getters['lang/locale']
      const { data } = await ctx.$axios.get('/api/content-page?link=careers&lang=' + lang)
      page = data

      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('careers-new'),
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      if (Object.keys(page).length === 0) {
        ctx.error({ statusCode: 404, message: 'Page not found' })
        return
      }

      return {
        lang,
        page
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      filter: 'all',
      limit: 9
    }
  },
  head () {
    return {
      title: this.page.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.data.meta_descrtiption
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.page.data.meta_keywords
        }
      ]
    }
  },
  computed: {
    ...mapState({
      windowBreakpoint: 'breakpoint'
    }),
    filteredJobs () {
      const sect = this.page.sections.find(s => s.type === 'jobs-list')
      if (this.filter === 'all') {
        return sect.jobsList.jobs.slice(0, this.limit)
      }
      return sect.jobsList.jobs.filter((j) => {
        return j.type === this.filter
      })
    },
    imageSections () {
      if (this.page && this.page.sections) {
        return this.page.sections.filter(i => i.type === 'image-text-right' || i.type === 'image-text-left')
      }
      return []
    },
    textSections () {
      if (this.page && this.page.sections) {
        return this.page.sections.filter(i => i.type === 'section-text')
      }
      return []
    },
    jsonFields () {
      if (this.page && this.page.sections) {
        return this.page.sections.filter(i => i.type === 'json-data')
      }
      return []
    },
    getSliderSettings: app => (name) => {
      const isSlider = app.$store.state.breakpoint.screen.widthMinCalc <= 1024
      const SETTINGS = {
        'discover-flotilla': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  arrows: false,
                  dots: true
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    }
  },
  methods: {
    scrollToJobs () {
      this.$scrollTo({ y: this.$refs.jobsList.offsetTop + 650 })
    },
    setActiveFAQ (number) {
      if (this.faq.active.includes(number)) {
        this.faq.active = this.faq.active.filter(v => v !== number)
        return
      }
      this.faq.active.push(number)
    },
    prepareFlagIcon (name) {
      return `/flags/${name.toLowerCase()}.svg`
    }
  }
}
